/** Back office — tenant branding and custom domain (ADR-0036). */
export const enBranding = {
  'bo.nav.branding': 'Branding',
  'error.platformMfaRequired':
    'Turn on an authenticator app under Account before using the platform console.',
  'bo.branding.title': 'Branding',
  'bo.branding.subtitle': 'Your name and logo on receipts and the guest QR menu.',
  'bo.branding.readOnly': 'Only the owner or an administrator can change branding.',
  'bo.branding.cardTitle': 'Receipt and menu',
  'bo.branding.cardDesc': 'Leave a field empty to use the branch name only.',
  'bo.branding.displayName': 'Business name',
  'bo.branding.displayNameHint': 'Shown above the branch name, e.g. “Warung Nusantara”.',
  'bo.branding.logoUrl': 'Logo URL',
  'bo.branding.logoUrlHint': 'An HTTPS link to a square image. Shown on the guest menu.',
  'bo.branding.logoInvalid': 'Enter a link that starts with https://',
  'bo.branding.receiptHeader': 'Receipt header',
  'bo.branding.receiptHeaderHint': 'e.g. address, phone or tax number. Up to 300 characters.',
  'bo.branding.receiptFooter': 'Receipt footer',
  'bo.branding.receiptFooterHint': 'e.g. Wi-Fi password or a thank-you note.',
  'bo.branding.tooLong': 'Up to {max} characters.',
  'bo.branding.submit': 'Save branding',
  'bo.branding.saved': 'Branding saved.',
  'bo.branding.conflict':
    'Someone else changed the branding. The latest version is shown; check it and save again.',
  'bo.branding.domain.title': 'Custom domain for the guest menu',
  'bo.branding.domain.desc':
    'Guests open the QR menu on your own address, e.g. menu.restaurant.id.',
  'bo.branding.domain.notInPlan': 'Custom domains are part of the Enterprise plan.',
  'bo.branding.domain.hostname': 'Domain',
  'bo.branding.domain.request': 'Connect domain',
  'bo.branding.domain.requested': 'Domain registered. Add the DNS record below.',
  'bo.branding.domain.check': 'Check status',
  'bo.branding.domain.remove': 'Remove domain',
  'bo.branding.domain.removed': 'Domain removed.',
  'bo.branding.domain.dns':
    'At your DNS provider, add a CNAME record for {hostname} pointing to {target}. The certificate is issued automatically once the record is visible (usually within an hour).',
  'bo.branding.domain.status.none': 'Not connected',
  'bo.branding.domain.status.pending': 'Waiting for DNS',
  'bo.branding.domain.status.active': 'Active',
  'bo.branding.domain.status.failed': 'Failed',
} as const;
